import React, { Component } from "react";
import {
    Row,
    Col,
    Table
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import moment from "moment";
import { getFullName } from "../../helpers/functions/employee";

class AwolReport extends Component {

    renderPeriod(period) {
        switch (period) {
            case 'am':
                return "AM";
            case 'pm':
                return "PM";
            default:
                return "Whole day";
        }
    }

    renderInstances(instances) {
        return instances.map((instance) => {
            return moment(instance.date, 'YYYY-MM-DD').format('MMM DD') + " (" + this.renderPeriod(instance.period) + ")";
        }).join(", ");
    }

    render() {

        const { reportData, year } = this.props;

        return (
            <Row>
              <div style={{
                marginTop: '60px'
              }}></div>
              <Col md={12}>
                <Card
                  title="AWOL Report"
                  category={year + " - employees with 4 AWOL days or more"}
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table
                      hover
                      responsive
                      striped
                    >
                      <thead>
                        <tr>
                          <th>Names</th>
                          <th>AWOL days</th>
                          <th>Whole days</th>
                          <th>Half days</th>
                          <th>Dates (period)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData && reportData.length > 0
                          ? reportData.map((employeeData) => {
                            return (
                              <tr key={employeeData.employee._id}>
                                <td>
                                  {getFullName(employeeData.employee)}
                                  <div className="text-muted">
                                    {employeeData.employee.employeeNumber}
                                  </div>
                                </td>
                                <td><strong>{employeeData.totalDays}</strong></td>
                                <td>{employeeData.wholeDayCount}</td>
                                <td>{employeeData.halfDayCount}</td>
                                <td>{this.renderInstances(employeeData.instances)}</td>
                              </tr>
                            )
                          })
                          : (
                            <tr>
                              <td colSpan='5'>No results found.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  }
                />
              </Col>
            </Row>
        )
    }
}

export default AwolReport;
